/**
 * 分類 API 服務
 * 使用 RTK Query 封裝分類相關的 API 調用
 */

import { createApi } from '@reduxjs/toolkit/query/react';

// 使用品牌 API 專用的 baseQuery（Bearer token 認證）
// 因為地區/城市/區域 API 在品牌編輯頁面中使用，需要與品牌 API 使用相同的認證方式
import { brandBaseQuery } from '@/services/baseApi';
import { IRegionsResponse, GetDistrictsResponse } from '@/types/regions';
import { ConstantUtil } from '@/utils/ConstantUtil';

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: brandBaseQuery, // 使用 Bearer token 認證
  tagTypes: ['Category'],
  endpoints: (builder) => ({
    // 獲取地區列表 - /api/v1/regions/summary（返回北、中、南、東部，包含城市和行政區）
    getRegions: builder.query<IRegionsResponse, { includeDistricts?: boolean }>({
      query: (params) => ({
        url: ConstantUtil.API_GET_REGIONS,
        method: 'GET',
        params,
      }),
      providesTags: ['Category'],
    }),
    // 獲取縣市行政區 - /api/v1/regions/city/{cityKey}/districts（返回該城市的行政區，如中正區、大同區等）
    getDistricts: builder.query<GetDistrictsResponse, string>({
      query: (cityKey) => ({
        url: ConstantUtil.API_GET_DISTRICTS(cityKey),
        method: 'GET',
      }),
      providesTags: ['Category'],
    }),
  }),
});

export const { useGetRegionsQuery, useGetDistrictsQuery } = categoryApi;
